import React from 'react'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import colors from '../../utils/colors'
import styles from '../../styles/viewer.module.css'
import {
  GetApp,
  Print,
  RotateLeft,
  RotateRight
} from '@material-ui/icons'

const theme = createTheme({
  overrides: {
    MuiAppBar: {
      root: {
        height: '35px'
      }
    },
    MuiSvgIcon: {
      root: {
        color: colors.gray01,
        cursor: 'pointer',
        height: '25px',
        margin: '0 5px',
        width: '25px'
      }
    },
    MuiToolbar: {
      root: {
        background: colors.baseBlue,
      },
      dense: {
        minHeight: '38px',
      }
    },
    MuiIconButton: {
      label: {
        '&>svg': {
          height: '20px',
          width: '20px',
        },
      },
      root: {
        color: colors.gray01,
      },
    }
  },
})

/*
const DownloadButton = ({
  fileType,
  filteData
}) => {}
*/

const FileActionsBar = ({
  fileContentType,
  fileData,
  fileType,
  handleBack,
  handleLeft,
  handlePrint,
  handleRight,
  showPrintIcon,
  showDownloadIcon,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static">
        <Toolbar variant="dense">
          {handleLeft &&
            <div className={styles.rotateLeftIcon}>
              <RotateLeft onClick={handleLeft} />
            </div>
          }
          {handleRight &&
            <div className={styles.rotateRightIcons}>
              <RotateRight onClick={handleRight} />
            </div>
          }

          {(showDownloadIcon && fileData && fileType === 'file-pdf') ? (
            <a href={`data:application/pdf;base64,${fileData}`} download="file.pdf" className={styles.downloadIcon}>
              <GetApp />
            </a>
          ) : null
          }

          {(showDownloadIcon && fileData && fileType === 'file-image') ? (
            <a href={`data:image/jpeg;base64,${fileData}`} download="file.jpeg" className={styles.downloadIcon}>
              <GetApp />
            </a>
          ) : null
          }

          {(showDownloadIcon && fileData && fileType === 'file-code') ? (
            <a href={`data:application/xml;base64,${fileData}`} download="file.xml" className={styles.downloadIcon}>
              <GetApp />
            </a>
          ) : null
          }

          {(showDownloadIcon && fileData && fileType === 'file-alt' && fileContentType) ? (
            <a href={`data:${fileContentType};base64,${fileData}`} download="file" className={styles.downloadIcon}>
              <GetApp />
            </a>
          ) : null

          }

          {(handlePrint && showPrintIcon) ? (
            <div className={styles.printIcon}>
              <Print onClick={handlePrint} />
            </div>
          ) : null
          }
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  )
}

export default FileActionsBar
